<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <invoice-include-list v-if="!isAvailableToSave"
        :data="includeToInvoiceList"
        @update:data="$emit('update:includeToInvoiceList', $event)"
      />
      <form-edit
        ref="Form"
        :data="data"
        :model="modelInvoice"
        @change="handleFormData"
        @onAutoSave="handleAutoSave"
      />
      <form-controls
        class="form-footer"
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isCreate="!isAvailableToSave"
        :isSave="isAvailableToSave"
        @command="setCommand"
      />
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { ModelInvoice, ENDPOINTS, ServiceInvoice } from '@/services/Invoice'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'

export default {
  name: 'Editor',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'form-edit': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './Form.vue'),
    'invoice-include-list': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './InvoiceIncludeList.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    includeToInvoiceList: { type: Array, required: true }
  },
  computed: {
    formTitle () {
      return this.formData.invoiceNumber || this.L10n('create-invoice')
    },
    isAvailableToSave () {
      return this.state === 'edit'
    },
    apiAutoSave () {
      return `${ENDPOINTS.PATCH}/${this.data.id}`
    },
    includeToList () {
      return this.includeToInvoiceList.filter(({ includeToInvoice }) => {
        return includeToInvoice
      })
    }
  },
  methods: {
    modelInvoice () {
      return this.copyObjectProps(ModelInvoice(), {
        rfqid: this.rfqid,
        po: this.po,
        countryOriginID: 3,
        totalPackages: 1,
        vatid: 4
      })
    },
    handleAutoSave (config) {
      const { field } = config
      this.mixAutoSave(config)
        .then(({ e }) => {
          if (e) return
          if (['invoiceNumber', 'rfqid'].some((fieldName) => fieldName === field)) {
            const { rfqid, id: invoiceID } = this.data
            return ServiceInvoice.creatInvoiceDetailsDynamic({ invoiceID, rfqid })
          }
        })
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    },
    hookCreated (data) {
      return Promise.all(this.includeToList.map(({ id }) => {
        return ServiceInvoice.createDetail({ rfqid: data.rfqid, rfq3ID: id, invoiceNumber: data.invoiceNumber })
      }))
        .then(() => {
          const id = data.id
          this.$nextTick(() => {
            const routeData = this.$router.resolve({ name: 'Invoices', query: { 'invoices': `edit[${id}]` } })
            window.open(routeData.href, '_blank')
          })
        })
        .catch((e) => {
          this.requestErrorHandler(e)
        })
    }
  }
}
</script>
